(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["arinna-category-tree"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('arinna-brand-dropdown')) {
  customElements.define('arinna-brand-dropdown', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const details = this.querySelector(':scope > details');
      const summary = details?.querySelector(':scope > summary');
      if (!details || !summary) return;
      const desktopHover = window.matchMedia('(min-width: 781px) and (hover: hover) and (pointer: fine)');
      let pointerInside = false;
      let hoverOpened = false;
      const closeAfterLeaving = () => {
        if (!pointerInside && !details.contains(document.activeElement)) {
          details.open = false;
          hoverOpened = false;
        }
      };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType !== 'mouse' || !desktopHover.matches) return;
        pointerInside = true;
        hoverOpened = !details.open;
        details.open = true;
      }, { signal });
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        pointerInside = false;
        if (desktopHover.matches) closeAfterLeaving();
      }, { signal });
      this.addEventListener('focusout', (event) => {
        if (desktopHover.matches && !this.contains(event.relatedTarget)) {
          pointerInside = this.matches(':hover');
          closeAfterLeaving();
        }
      }, { signal });
      summary.addEventListener('click', (event) => {
        if (event.detail > 0 && pointerInside && hoverOpened && desktopHover.matches) {
          event.preventDefault();
          hoverOpened = false;
        }
      }, { signal });
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.preventDefault();
        event.stopPropagation();
        details.open = false;
        hoverOpened = false;
        summary.focus();
      }, { signal });
      desktopHover.addEventListener('change', () => {
        if (!desktopHover.matches) {
          pointerInside = false;
          if (hoverOpened && !details.contains(document.activeElement)) details.open = false;
          hoverOpened = false;
        }
      }, { signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
